import React, { useEffect, useMemo, useState } from "react";
import { translate, translateDate, translateElapsed } from "../../../../../../common/providers";
import styles from "./Summary.module.css";
import { CustomButton } from "../../../../../../common/components";
import ComponentsTextField from "../../../../../../common/components/text-fields/components-textfield/ComponentsTextField";

const Summary = ({ isEditing = false, onSaveEditing, summary = null }) => {
	const [tempSummary, setTempSummary] = useState(summary.summary);
	const [showAll, setShowAll] = useState(false);
	const isOverflowing = useMemo(() => tempSummary?.length > 1000, [tempSummary]);
	const adjustedSummary = useMemo(
		() => (showAll ? summary.summary : summary.summary?.substring(0, 1000)),
		[summary, showAll]
	);
	useEffect(() => {
		setTempSummary(summary.summary);
	}, [summary.summary]);
	const handleChangeTempSummary = (e) => {
		setTempSummary(e.target.value);
	};
	const handleChangeShowAll = () => {
		setShowAll((prev) => !prev);
	};
	const handleSaveEditing = () => {
		if (typeof onSaveEditing === "function") {
			onSaveEditing(tempSummary);
		}
	};
	return (
		<div className={styles.container}>
			<div className={styles.metadata}>
				{(summary.isEdited && translate("dashboards.project.project-summary.summary.edited")) ||
					translate("dashboards.project.project-summary.summary.generated")}
				&nbsp;
				{translateDate(summary.isEdited ? summary.lastModified : summary.created)} |&nbsp;
				{translateElapsed(
					summary.isEdited
						? {
								value: summary?.modifiedElapsed?.value,
								unitKey: summary?.modifiedElapsed?.unit,
						  }
						: {
								value: summary?.createdElapsed?.value,
								unitKey: summary?.createdElapsed?.unit,
						  }
				)}
			</div>
			{(isEditing && (
				<ComponentsTextField
					className={styles.textField}
					value={tempSummary}
					onChange={handleChangeTempSummary}
				/>
			)) || (
				<div className={styles.summary}>
					<span>
						{adjustedSummary?.split("\n").map((s) => (
							<p key={s} className={styles.summaryLine}>
								{s || <>&nbsp;</>}
							</p>
						))}
					</span>
					{isOverflowing && (
						<span>
							<CustomButton size="sm" onClick={handleChangeShowAll}>
								{showAll ? translate("common:btn.show-less") : translate("common:btn.show-more")}
							</CustomButton>
						</span>
					)}
				</div>
			)}
			{isEditing && (
				<div className={styles.editButton__container}>
					<CustomButton color="secondary" size="sm" variant="outlined" onClick={handleSaveEditing}>
						{translate("common:btn.validate")}
					</CustomButton>
				</div>
			)}
		</div>
	);
};

export default Summary;
